import { RootState } from '../reducers/rootReducer';

export const regionSelector = (state: RootState) => {
  return state?.region.countries;
}

